import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { Button } from '@fiverr-private/button';
import { Typography } from '@fiverr-private/typography';
import { DrawerFooter } from '@fiverr-private/overlay';
import { appTranslate } from '../../i18n';

interface SubscriptionFooterProps {
    onSubmit: () => void;
    loading: boolean;
    disabled?: boolean;
    totalPrice: string | null;
}

export const SubscriptionFooter = ({ onSubmit, totalPrice, loading, disabled = false }: SubscriptionFooterProps) => (
    <DrawerFooter>
        <Container marginBottom="2">
            <Button fullWidth type="button" loading={loading} onClick={onSubmit} disabled={disabled}>
                {appTranslate('subscription_drawer.continue')} ({totalPrice})
            </Button>
        </Container>
        <Typography textAlign="center" size="b_xs" color="grey_1000">
            {appTranslate('subscription_drawer.hint')}
        </Typography>
    </DrawerFooter>
);
